import type { IllustrationName } from '@/ui/illustrations/illustration/Illustration'
import { Illustration } from '@/ui/illustrations/illustration/Illustration'
import { Link } from '@/ui/links/link/Link.client'

const CARD_CLASSNAME =
  'flex w-[10.25rem] flex-col items-center gap-1 text-center leading-light text-current desktop:w-[13.125rem] desktop-lg:w-[15.3125rem]'

export const ReassuranceCategoryKeys = {
  products: 'products',
  shipping: 'shipping',
  clickNCollect: 'clickNCollect',
  loyalty: 'loyalty',
  services: 'services',
  stores: 'stores',
} as const

export type ReassuranceCardProps = {
  /** The illustration shown on the card */
  illustration: IllustrationName

  /** The link attached to the card  */
  href?: string | null

  /** The first line of text */
  line1?: string | null

  /** The second line of text */
  line2?: string | null
}

export function ReassuranceCard({
  line1,
  line2,
  href,
  illustration,
}: ReassuranceCardProps): React.ReactElement {
  const content = (
    <>
      <div className="mx-auto flex size-10">
        <Illustration name={illustration} data-testid="reassurance-card/illustration" />
      </div>

      {!!line1 && <p className="font-bold">{line1}</p>}
      {!!line2 && <p>{line2}</p>}
    </>
  )

  if (!href || href === '#') {
    return (
      <div className={CARD_CLASSNAME} data-testid="reassurance-card">
        {content}
      </div>
    )
  }

  return (
    <Link
      variant="free"
      underlined="hover"
      href={href}
      className={CARD_CLASSNAME}
      data-testid="reassurance-card"
      trackingData={{
        event: 'gaEvent',
        eventCategory: 'footer',
        eventAction: 'réassurance',
        eventLabel: line1 ?? '',
      }}
    >
      {content}
    </Link>
  )
}
